"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionCreateDto = void 0;
const transaction_1 = require("../transaction");
const misc_1 = require("../../../misc");
class TransactionCreateDto extends (0, misc_1.generateCreateDto)(transaction_1.Transaction, ['amount', 'extraData', 'description']) {
}
exports.TransactionCreateDto = TransactionCreateDto;
